import React from 'react';
import SolvedSubgrid from './SolvedSubgrid';

const SolvedGrid = () => {
  return (
    <div className="controlGrid grid">
      <div className="controlGridFlipper">

        <div className="controlGridContents solvedGrid">
          <SolvedSubgrid subgridId={0}/>

          <SolvedSubgrid subgridId={1}/>

          <SolvedSubgrid subgridId={3}/>

          <SolvedSubgrid subgridId={2}/>
        </div>

      </div>
    </div>
  );
};

export default SolvedGrid;